import { GridStateSnapshot } from 'react-virtuoso';
import { create } from 'zustand';

type UseTalentsGridState = {
  state?: GridStateSnapshot;
  setState: (d: UseTalentsGridState['state']) => void;
};

export const useTalentsGridState = create<UseTalentsGridState>((set) => ({
  state: undefined,
  setState: (d) => set({ state: d }),
}));
